import { Badge } from '@/components/ui/badge'
import type { EstadoPresupuesto } from '@/types/database'

const ESTADO_CONFIG: Record<EstadoPresupuesto, { variant: 'default' | 'secondary' | 'destructive' | 'outline'; label: string }> = {
  borrador: { variant: 'secondary', label: 'Borrador' },
  enviado: { variant: 'outline', label: 'Enviado' },
  aceptado: { variant: 'default', label: 'Aceptado' },
  rechazado: { variant: 'destructive', label: 'Rechazado' },
}

interface EstadoPresupuestoBadgeProps {
  estado: EstadoPresupuesto
}

export function EstadoPresupuestoBadge({ estado }: EstadoPresupuestoBadgeProps) {
  const config = ESTADO_CONFIG[estado] ?? { variant: 'secondary' as const, label: estado }
  return <Badge variant={config.variant}>{config.label}</Badge>
}
